const Dot = ({ color }) => (
  <div className="w-3 h-3 rounded-xl mr-1 border border-black" style={{ background: color }} />
)

export default Dot
